<template>
<div class="chapter">
<div class="inner_page">
<p class="block_2">
<span lang="en">
</span></p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_2" lang="en">Dedication</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_3" lang="en">To Jolanta.</p>
<p class="block_3" lang="en">Also, to the people of Greece,</p>
<p class="block_3" lang="en">who received me so well.</p>
<p class="block_4" id="calibre_pb_1" lang="en"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?313d893a